export const ROUTE_PATHS = {
  LOGIN_PAGE: '/login',
  RESET_PASSWORD_PAGE: '/auth/reset-password',
  MODE_PAGE: '/mode',
  CHAT_PAGE: '/chat',
  CATALOG_LIST_PAGE: '/chat/catalog_list',
  CATALOG_DETAIL: '/chat/catalog_detail'
}